import React, { useEffect, useState } from 'react';
import {
  useMemorizeFilters,
  POSSIBLE_FILTERS_ENTITIES
} from 'hooks/useMemorizeInputsFilters';
import { useForm, Controller } from 'react-hook-form';
import userService from '../../../../src/views/Report/SatisfactionSurvey/Analytical/service/UserService';
import { ErrorMessage } from '@hookform/error-message';
import { toast } from 'react-toastify';
import { format, startOfMonth } from 'date-fns';
import FlexSelect from '../../../../src/components/Inputs/FlexSelect';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import Loader from 'react-loader-spinner';
import DatePicker from 'components/Inputs/DatePicker.js';
import { useSelector } from 'react-redux';
import {
  Container,
  Row,
  Card,
  Form,
  Col,
  CardHeader,
  Button,
  CardBody
} from 'reactstrap';

import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import Pagination from 'components/Pagination';
import Table from './tables/Analytical';
import ReportAnalytical from './tables/ReportAnalytical';
import OverallAverageQuestionnaire from './tables/OverallAverageQuestionnaire';
import AssessmentService from './service';
import { dateRules, hourRules } from '../Callcenter/utils/rulesValidation';
import HourMaskMMHHSS from 'components/Inputs/HourMaskMMHHSS.js';
import { ClearFiltersButton } from 'components/ClearFiltersButton';
import { reportOptions } from './utils/types';
import { ImageButton, ImageSize } from '../../../assets/styles/image_style';
import csvImage from '../../../assets/img/csv.png';
import pdfImage from '../../../assets/img/pdf.png';
import { Tooltip } from '@material-ui/core';
import { saveAs } from 'file-saver';
import { useGetQueues } from '../hooks/useGetQueues';
import { ItemPerPageSelect } from 'components/Inputs/ItemPerPageSelect';

const ConversationReport = () => {
  const { control, handleSubmit, errors, setValue, watch, getValues } =
    useForm();
  const { getMemorizedFilters, memorizeFilters, clearMemorizedFilters } =
    useMemorizeFilters(POSSIBLE_FILTERS_ENTITIES.REPORT_QUALITY_MONITORING);
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [dataToSend, setDataToSend] = useState({});
  const [assessments, setAssessments] = useState([]);
  const [agent, setAgent] = useState([]);
  // comentando a implementação de autor
  const [author, setAuthor] = useState([]);
  const reportType = watch('reportType');
  const [ReportTypeAnalytical, setReportTypeAnalytical] = useState([]);
  const [ReportTypeSynthetical, setReportTypeSynthetical] = useState([]);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [itemPerPage, setItemsPerPage] = useState(10);
  const { queues } = useGetQueues();
  useEffect(() => {
    const formValues = getValues();
    if (agent.length > 0) {
      onSubmit(formValues, false);
    }
  }, [agent]);

  useEffect(() => {
    if (reportType === 1) {
      setQuantity(0);
      setReportTypeSynthetical([]);
    } else if (reportType === 2) {
      setQuantity(0);
      setReportTypeAnalytical([]);
    }
  }, [reportType]);

  async function getAssessment(data, page) {
    setIsTableLoading(true);

    try {
      const res = await AssessmentService.getAssessmentAnalytics(
        {
          ...data,
          size: Number(itemPerPage) || 10
        },
        page
      );

      if (res.data.totalRegisters === 0) {
        toast.info('Nenhum registro foi encontrado!');
      }

      setAssessments(res.data.data);
      setQuantity(res.data.totalRegisters);
      setIsTableLoading(false);
    } catch (error) {
      toast.error('Ocorreu um erro buscar relatório', {
        autoClose: 3000,
        closeOnClick: true
      });
      setIsTableLoading(false);
    }
  }

  const handleReportexport = async (typeExport, e) => {
    e.preventDefault();
    const data = getDataDTO(getValues());
    data.exportType = typeExport;
    if (typeExport === 'CSV') {
      setLoadingCSV(true);
      await AssessmentService.getAssessmentFile(data)
        .then((res) => {
          if (res?.data?.size === 0) {
            setLoadingCSV(false);
            toast.info('Nenhum registro foi encontrado!');
          } else {
            saveAs(
              new Blob([res.data], {
                type: 'application/octet-stream'
              }),
              `relatorio-monitoria-qualidade-${
                data?.reportType === 1 ? 'Analítico' : 'Sintético'
              }.csv`
            );
            setLoadingCSV(false);
          }
        })
        .catch(() => {
          setLoadingCSV(false);
          toast.error('Ocorreu um erro ao gerar o relatório CSV', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    } else if (typeExport === 'PDF') {
      setLoadingPDF(true);
      await AssessmentService.getAssessmentFile(data)
        .then((res) => {
          if (res?.data?.size === 0) {
            setLoadingPDF(false);
            toast.info('Nenhum registro foi encontrado!');
          } else {
            saveAs(
              new Blob([res.data], {
                type: 'application/pdf'
              }),
              `relatorio-monitoria-qualidade-${
                data?.reportType === 1 ? 'Analítico' : 'Sintético'
              }.pdf`
            );
            setLoadingPDF(false);
          }
        })
        .catch(() => {
          setLoadingPDF(false);
          toast.error('Ocorreu um erro ao gerar o relatório PDF', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    }
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    const prevFilters = getMemorizedFilters();
    memorizeFilters({
      ...prevFilters,
      page
    });
    getAssessment(dataToSend, page);
  };

  const getDateBegin = () => {
    const date = new Date();
    const firstDayMonth = new Date(
      date.getFullYear('pt-br'),
      date.getMonth('pt-br'),
      1
    );
    const dateBegin = format(startOfMonth(firstDayMonth), 'dd/LL/yyyy');
    return dateBegin;
  };

  const toISOFormat = (dateTimeString, bar = false) => {
    const [date] = dateTimeString.split(' ');
    const [DD, MM, YYYY] = date.split('/');

    if (bar) return `${MM}/${DD}/${YYYY}`;
    return `${YYYY}-${MM}-${DD}`;
  };

  const getDataDTO = (data) => {
    const formatedData = {
      dateBegin: `${toISOFormat(data.dateBegin, true)} ${data.timeStart}`,
      dateEnd: `${toISOFormat(data.dateEnd, true)} ${data.timeEnd}`,
      user: data.atendente || '',
      author: data.autor || '',
      reportType: data.reportType || 1,
      exportType: '',
      queue: data.queue || []
    };
    return formatedData;
  };

  useEffect(() => {
    userService
      .getAll(false, undefined, undefined, true)
      .then((response) => {
        setAgent(response.data.data);
        setAuthor(response.data.data);
      })
      .catch((err) => {
        console.log('error:' + err);
      });
  }, []);

  useEffect(() => {
    if (!Object.keys(dataToSend || {}).length) return;

    setActivePage(1);
    const prevFilters = getMemorizedFilters();
    memorizeFilters({
      ...prevFilters,
      page: 1
    });

    getAssessment(dataToSend, 1);
  }, [itemPerPage]);

  useEffect(() => {
    const memorizedItemPerPage = Number(getMemorizedFilters()?.size);
    if (memorizedItemPerPage) {
      setItemsPerPage(memorizedItemPerPage);
    }
  }, []);

  const onSubmit = async (data, isNotFromUseEffect = true) => {
    let pageSavedOnMemory = 1;

    if (!isNotFromUseEffect) {
      pageSavedOnMemory = getMemorizedFilters()?.page || 1;
    }

    setActivePage(pageSavedOnMemory);
    memorizeFilters({
      ...(getMemorizedFilters() || {}),
      ...data,
      page: pageSavedOnMemory,
      size: Number(itemPerPage) || 10
    });

    const formatedData = getDataDTO(data);
    setDataToSend(formatedData);
    getAssessment(formatedData, pageSavedOnMemory);
  };

  const handleReset = () => {
    const defaultFieldValues = {
      dateBegin: getDateBegin(),
      timeStart: '00:00:00',
      dateEnd: new Date().toLocaleDateString('pt-br'),
      timeEnd: '23:59:59',
      atendente: '',
      autor: ''
    };

    for (const key in defaultFieldValues) {
      setValue(`${key}`, defaultFieldValues[key]);
    }

    clearMemorizedFilters();
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Relatório de Monitoria de Qualidade</h3>
                </CardHeader>
                <CardBody>
                  <Form
                    className="needs-validation"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <ClearFiltersButton handleOnClick={handleReset} />
                    <Row className="mb-3">
                      <Col md="6">
                        <label className="form-control-label">
                          Data inicial*
                        </label>
                        <Controller
                          render={(props) => (
                            <DatePicker
                              fieldName="dateBegin"
                              valueController={setValue}
                              defaultValue={props.value}
                            />
                          )}
                          control={control}
                          name="dateBegin"
                          rules={dateRules}
                          defaultValue={
                            getMemorizedFilters()?.dateBegin || getDateBegin()
                          }
                        />
                        <ErrorMessage
                          errors={errors}
                          name="dateBegin"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                      <Col md="6">
                        <label className="form-control-label">
                          Hora inicial*
                        </label>
                        <Controller
                          render={(props) => (
                            <HourMaskMMHHSS
                              valueController={setValue}
                              fieldName="timeStart"
                              value={props.value}
                            />
                          )}
                          control={control}
                          name="timeStart"
                          rules={hourRules}
                          defaultValue={
                            getMemorizedFilters()?.timeStart || '00:00:00'
                          }
                        />
                        <ErrorMessage
                          errors={errors}
                          name="timeStart"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="6">
                        <label className="form-control-label">
                          Data final*
                        </label>
                        <Controller
                          render={(props) => (
                            <DatePicker
                              fieldName="dateEnd"
                              valueController={setValue}
                              defaultValue={props.value}
                            />
                          )}
                          control={control}
                          name="dateEnd"
                          defaultValue={
                            getMemorizedFilters()?.dateEnd ||
                            new Date().toLocaleDateString('pt-br')
                          }
                          rules={{
                            ...dateRules,
                            validate: (value) => {
                              if (
                                new Date(toISOFormat(value, true)) <
                                new Date(
                                  toISOFormat(getValues()['dateBegin'], true)
                                )
                              ) {
                                return 'A data final não pode ser anterior à inicial!';
                              } else {
                                return true;
                              }
                            }
                          }}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="dateEnd"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                      <Col md="6">
                        <label className="form-control-label">
                          Hora final*
                        </label>
                        <Controller
                          render={(props) => (
                            <HourMaskMMHHSS
                              valueController={setValue}
                              fieldName="timeEnd"
                              value={props.value}
                            />
                          )}
                          control={control}
                          name="timeEnd"
                          rules={{
                            ...hourRules,
                            validate: (value) => {
                              const timeStart = getValues()['timeStart'];
                              if (value < timeStart) {
                                return 'A hora final não pode ser anterior à inicial no mesmo dia!';
                              }
                            }
                          }}
                          defaultValue={
                            getMemorizedFilters()?.timeEnd || '23:59:59'
                          }
                        />
                        <ErrorMessage
                          errors={errors}
                          name="timeEnd"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="4">
                        <label className="form-control-label">Agente</label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={agent}
                              isMulti={true}
                              isClearable={true}
                              value={props.value}
                              closeMenuOnSelect={true}
                              valueController={setValue}
                              fieldName="atendente"
                              labelName="name"
                              valueName="name"
                            />
                          )}
                          control={control}
                          name="atendente"
                          defaultValue={getMemorizedFilters()?.atendente || ''}
                        />

                        <label className="form-control-label mt-3">
                          Tipo de Relatório
                        </label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={reportOptions}
                              isMulti={false}
                              value={props.value}
                              valueController={setValue}
                              closeMenuOnSelect={true}
                              fieldName="reportType"
                              labelName="label"
                              valueName="value"
                            />
                          )}
                          control={control}
                          name="reportType"
                          defaultValue={getMemorizedFilters()?.reportType ?? 1}
                        />
                      </Col>
                      <Col md="4">
                        <label className="form-control-label">Autor</label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={author}
                              isMulti={true}
                              isClearable={true}
                              value={props.value}
                              closeMenuOnSelect={true}
                              valueController={setValue}
                              fieldName="autor"
                              labelName="name"
                              valueName="name"
                            />
                          )}
                          control={control}
                          name="autor"
                          defaultValue={getMemorizedFilters()?.autor || ''}
                        />
                      </Col>
                      <Col md="4">
                        <label className="form-control-label">Fila(s)</label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={
                                queues?.filter?.((q) => q.is_telephony) ?? []
                              }
                              isMulti={true}
                              isClearable={true}
                              value={props.value}
                              closeMenuOnSelect={false}
                              valueController={setValue}
                              fieldName="queue"
                              labelName="name"
                              valueName="id"
                            />
                          )}
                          control={control}
                          name="queue"
                          defaultValue={getMemorizedFilters()?.queue ?? ''}
                        />
                      </Col>
                    </Row>

                    <br />
                    <Row className="mb-4 align-items-center">
                      <Col xs="auto">
                        <Button
                          style={buttonStyle(systemConfiguration.primary_color)}
                          type="submit"
                          disabled={isTableLoading}
                        >
                          {isTableLoading ? (
                            <Loader
                              type="TailSpin"
                              color="white"
                              height={18}
                              width={78}
                            />
                          ) : (
                            'Buscar'
                          )}
                        </Button>
                      </Col>
                      <Col xs="auto">
                        <ItemPerPageSelect
                          valueController={setItemsPerPage}
                          entity={
                            POSSIBLE_FILTERS_ENTITIES.REPORT_QUALITY_MONITORING
                          }
                        ></ItemPerPageSelect>
                      </Col>
                      <Col xs="auto" className="ml-auto">
                        <button
                          id="button_csv"
                          style={ImageButton}
                          onClick={(e) => handleReportexport('CSV', e)}
                        >
                          <Tooltip
                            title={
                              <p style={{ fontSize: 14 }}>
                                {assessments?.length
                                  ? `Fazer download do relatório de Monitoria de Qualidade.`
                                  : 'Nenhum registro para realizar download'}
                              </p>
                            }
                            arrow
                          >
                            {loadingCSV ? (
                              <Loader
                                type="ThreeDots"
                                visible
                                height={40}
                                width={40}
                                color={systemConfiguration.primary_color}
                              />
                            ) : (
                              <img src={csvImage} alt="csv" style={ImageSize} />
                            )}
                          </Tooltip>
                        </button>
                        <button
                          id="button_pdf"
                          style={ImageButton}
                          onClick={(e) => handleReportexport('PDF', e)}
                        >
                          <Tooltip
                            title={
                              <p style={{ fontSize: 14 }}>
                                {assessments?.length
                                  ? `Fazer download do relatório de Monitoria de Qualidade.`
                                  : 'Nenhum registro para realizar download'}
                              </p>
                            }
                            arrow
                          >
                            {loadingPDF ? (
                              <Loader
                                type="ThreeDots"
                                visible
                                height={40}
                                width={40}
                                color={systemConfiguration.primary_color}
                              />
                            ) : (
                              <img src={pdfImage} alt="pdf" style={ImageSize} />
                            )}
                          </Tooltip>
                        </button>
                      </Col>
                    </Row>
                  </Form>
                  {isTableLoading ? (
                    <Row className="justify-content-md-center">
                      <Loader
                        type="TailSpin"
                        color={systemConfiguration.primary_color}
                        height={100}
                        width={100}
                      />
                    </Row>
                  ) : (
                    quantity !== 0 && (
                      <>
                        {reportType === 1 ? (
                          <ReportAnalytical
                            showReports={ReportTypeAnalytical}
                            data={assessments}
                            quantity={quantity}
                            totalRegister={quantity}
                          />
                        ) : reportType === 2 ? (
                          <OverallAverageQuestionnaire
                            showReports={ReportTypeSynthetical}
                            data={assessments}
                            quantity={quantity}
                            totalRegister={quantity}
                          />
                        ) : (
                          <Table
                            data={assessments}
                            quantity={quantity}
                            totalRegister={quantity}
                          />
                        )}

                        <Pagination
                          activePage={activePage}
                          totalItemsCount={quantity}
                          itemsCountPerPage={Number(itemPerPage) || 10}
                          onChange={handlePageChange.bind(this)}
                        />
                      </>
                    )
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ConversationReport;
